import React from 'react';
import ReactDOM from 'react-dom';
import "./components/css/Index.css";
import "bootstrap/dist/css/bootstrap.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Navigation,
  Footer,
  Home,
  Slideshow,
  About,
  Editions,
  Publication,
  Error,
} from "./components";

ReactDOM.render(
  <Router>
    {/* <scrollToTop /> */}
    {/* <Popup /> */}
    <Navigation />
    <Routes>
      <Route path="/home" element={<Home />} >
        <Route path="" element={<><Slideshow /><Editions /><About /> </>} />
      </Route>
      <Route path="/" element={<Home />} >
        <Route path="" element={<><Slideshow /><Editions /><About /> </>} />
      </Route>

      <Route path="/editions/june21-edition" element={<><Publication edition={0} /></>} />
      <Route path="//editions/july21-edition" element={<><Publication edition={1} /></>} />
      <Route path="/editions/august21-edition" element={<><Publication edition={2} /></>} />
      <Route path="/editions/september21-edition" element={<><Publication edition={3} /></>} />
      <Route path="/editions/october21-edition" element={<><Publication edition={4} /></>} />
      <Route path="/editions/winter21-edition" element={<><Publication edition={5} /></>} />
      <Route path="/editions/january22-edition" element={<><Publication edition={6} /></>} />
      <Route path="/editions/february22-edition" element={<><Publication edition={7} /></>} />
      <Route path="/editions/april22-edition" element={<><Publication edition={8} /></>} />
      <Route path="/editions/june22-edition" element={<><Publication edition={9} /></>} />
      <Route path="/editions/july22-edition" element={<><Publication edition={10} /></>} />
      <Route path="/editions/oct22-edition" element={<><Publication edition={11} /></>} />


      <Route path="/editions/latest-issue" element={<><Publication edition={11} /></>} />

      <Route path="*" element={<Error />} />
    </Routes>
    <Footer />
  </Router>,

  // <div className="text">
  //   <p>17041e9f83690d6cf896b9d686512d491c1181c0</p>
  // </div>,

  document.getElementById("root")
);